import React, { createContext, useReducer, useContext } from "react";
import { LiferayService } from "../../../common/services/liferay/index";
import { ApplicationPropertiesContext } from "../../../common/context/ApplicationPropertiesProvider";
import { decode_utf8 } from "../../../common/utils/utilsFunc";
import { AccessTokenContext } from "../../../common/context/AccessTokenProvider";

export const SubscriptionsContext = createContext();
export const ACTIONS = {
  SET_IDCLIENT: "SET_IDCLIENT",
  SET_IDLIST: "SET_IDLIST",
  SET_IDCLIENT_AUX:"SET_IDCLIENT_AUX",
  SET_ERROR: "SET_ERROR",
  SET_CURRENT_BALANCE: "SET_CURRENT_BALANCE",
  SET_WEB_CONTENT_TEXT_INFO: "SET_WEB_CONTENT_TEXT_INFO",
  SET_WEB_CONTENT_ALTA_SUBSCRIPTION_TEXT_INFO: "SET_WEB_CONTENT_ALTA_SUBSCRIPTION_TEXT_INFO",
  SET_WEB_CONTENT_ANULATION_SUBSCRIPTION_TEXT_INFO: "SET_WEB_CONTENT_ANULATION_SUBSCRIPTION_TEXT_INFO",
  SET_WEB_CONTENT_NOTE_SUBSCRIPTION_PUB: "SET_WEB_CONTENT_NOTE_SUBSCRIPTION_PUB",
  SET_WEB_CONTENT_MODIFICATION_SUBSCRIPTION_EMAIL: "SET_WEB_CONTENT_MODIFICATION_SUBSCRIPTION_EMAIL",
  SET_JSON_ALTA_SUBSCRIPTION: "SET_JSON_ALTA_SUBSCRIPTION",
  SET_RESPONSE_ALTA_SUBSCRIPTION: "SET_RESPONSE_ALTA_SUBSCRIPTION",
  SET_JSON_CONFIRMATION_ALTA_SUBSCRIPTION: "SET_JSON_CONFIRMATION_ALTA_SUBSCRIPTION",
  SET_RESPONSE_CONFIRMATION_ALTA_SUBSCRIPTION: "SET_RESPONSE_CONFIRMATION_ALTA_SUBSCRIPTION",
  SET_JSON_ANULATION_SUBSCRIPTION: "SET_JSON_ANULATION_SUBSCRIPTION",
  SET_RESPONSE_ANULATION_SUBSCRIPTION: "SET_RESPONSE_ANULATION_SUBSCRIPTION",
  SET_JSON_VERIFICATE_MODIFICATION_SUBSCRIPTION: "SET_JSON_VERIFICATE_MODIFICATION_SUBSCRIPTION",
  SET_RESPONSE_VERIFICATE_MODIFICATION_SUBSCRIPTION: "SET_RESPONSE_VERIFICATE_MODIFICATION_SUBSCRIPTION",
  SET_JSON_MODIFICATION_SUBSCRIPTION: "SET_JSON_MODIFICATION_SUBSCRIPTION",
  SET_RESPONSE_MODIFICATION_SUBSCRIPTION: "SET_RESPONSE_MODIFICATION_SUBSCRIPTION",
  SET_JSON_CONFIRMATION_MODIFICATION_SUBSCRIPTION: "SET_JSON_CONFIRMATION_MODIFICATION_SUBSCRIPTION",
  SET_RESPONSE_CONFIRMATION_MODIFICATION_SUBSCRIPTION: "SET_RESPONSE_CONFIRMATION_MODIFICATION_SUBSCRIPTION",
  SET_DETAIL_CLIENT: "SET_DETAIL_CLIENT",
  SET_LIST_SUBSCRIPCIONES: "SET_LIST_SUBSCRIPCIONES"
};
const initialState = {
  errorFetch: null,
  idList: null,
  idClient: null,
  currentBalance: null,
  webContentTextInfo: null,
  webContentAltaSubscriptionTextInfo: null,
  webContentAnulationSubscriptionTextInfo: null,
  webContentNoteSubscriptionPub: null,
  webContentModificationSubscriptionEmail: null,
  jsonAltaSubscription: null,
  responseAltaSubscription: null,
  jsonConfirmationAltaSubscription: null,
  responseConfirmationAltaSubscription: null,
  jsonAnulationSubscription: null,
  responseAnulationSubscription: null,
  jsonVerificateModificationSubscription: null,
  responseVerificateModificationSubscription: null,
  jsonModificationSubscription: null,
  responseModificationSubscription: null,
  jsonConfirmationModificationSubscription: null,
  responseConfirmationModificationSubscription: null,
  idClient: null,
  detailClient: null,
  idClientAux: null,
  listSuscripciones: null,

};
const SubscriptionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_IDLIST: {
      return {
        ...state,
        idList: action.payload,
      };
    }
    case ACTIONS.SET_IDCLIENT_AUX: {
      return {
          ...state,
          idClientAux: action.payload
      };
    }
    case ACTIONS.SET_IDCLIENT: {
      return {
        ...state,
        idClient: action.payload,
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        errorCatch: action.payload,
      };
    }
    case ACTIONS.SET_CURRENT_BALANCE: {
      return {
        ...state,
        currentBalance: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_TEXT_INFO: {
      return {
        ...state,
        webContentTextInfo: action.payload,
      };

    }
    case ACTIONS.SET_WEB_CONTENT_ALTA_SUBSCRIPTION_TEXT_INFO: {
      return {
        ...state,
        webContentAltaSubscriptionTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_ANULATION_SUBSCRIPTION_TEXT_INFO: {
      return {
        ...state,
        webContentAnulationSubscriptionTextInfo: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_NOTE_SUBSCRIPTION_PUB: {
      return {
        ...state,
        webContentNoteSubscriptionPub: action.payload,
      };
    }
    case ACTIONS.SET_WEB_CONTENT_MODIFICATION_SUBSCRIPTION_EMAIL: {
      return {
        ...state,
        webContentModificationSubscriptionEmail: action.payload,
      };
    }
    case ACTIONS.SET_JSON_ALTA_SUBSCRIPTION: {
      return {
        ...state,
        jsonAltaSubscription: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_ALTA_SUBSCRIPTION: {
      return {
        ...state,
        responseAltaSubscription: action.payload,
      };
    }
    case ACTIONS.SET_JSON_CONFIRMATION_ALTA_SUBSCRIPTION: {
      return {
        ...state,
        jsonConfirmationAltaSubscription: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_CONFIRMATION_ALTA_SUBSCRIPTION: {
      return {
        ...state,
        responseConfirmationAltaSubscription: action.payload,
      };
    }
    case ACTIONS.SET_JSON_ANULATION_SUBSCRIPTION: {
      return {
        ...state,
        jsonAnulationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_ANULATION_SUBSCRIPTION: {
      return {
        ...state,
        responseAnulationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_JSON_VERIFICATE_MODIFICATION_SUBSCRIPTION: {
      return {
        ...state,
        jsonVerificateModificationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_VERIFICATE_MODIFICATION_SUBSCRIPTION: {
      return {
        ...state,
        responseVerificateModificationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_JSON_MODIFICATION_SUBSCRIPTION: {
      return {
        ...state,
        jsonModificationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_MODIFICATION_SUBSCRIPTION: {
      return {
        ...state,
        responseModificationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_JSON_CONFIRMATION_MODIFICATION_SUBSCRIPTION: {
      return {
        ...state,
        jsonConfirmationModificationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_RESPONSE_CONFIRMATION_MODIFICATION_SUBSCRIPTION: {
      return {
        ...state,
        responseConfirmationModificationSubscription: action.payload,
      };
    }
    case ACTIONS.SET_DETAIL_CLIENT: {
      return {
        ...state,
        detailClient: action.payload
      };
    }
    case ACTIONS.SET_LIST_SUBSCRIPCIONES: {
      return {
        ...state,
        listSuscripciones: action.payload
      };
    }
    default: {
      return state;
    }
  }
};
const SubscriptionsContextProvider = ({ children }) => {
  const properties = useContext(ApplicationPropertiesContext);

  const [state, dispatch] = useReducer(SubscriptionsReducer, initialState);

  const { accessToken } = useContext(AccessTokenContext);

  React.useEffect(() => {    
    if (properties.web_content_info_update_of_contact_information) {
      LiferayService.getWebContent(properties.base_url_api, properties.web_content_info_update_of_contact_information)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_TEXT_INFO,
          });
        })
    }

    if (decode_utf8(properties.web_content_alta_subscription)) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_alta_subscription))
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_ALTA_SUBSCRIPTION_TEXT_INFO,
          });
        })
    }

    if (decode_utf8(properties.web_content_anulation_subscription)) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_anulation_subscription))
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_ANULATION_SUBSCRIPTION_TEXT_INFO,
          });
        })
    }

    if (decode_utf8(properties.web_content_note_subscription_pub)) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_note_subscription_pub))
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_NOTE_SUBSCRIPTION_PUB,
          });
        })
    }

    if (decode_utf8(properties.web_content_modification_subscription_email)) {
      LiferayService.getWebContent(properties.base_url_api, decode_utf8(properties.web_content_modification_subscription_email))
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_WEB_CONTENT_MODIFICATION_SUBSCRIPTION_EMAIL,
          });
        })
    }
  }, []);

  React.useEffect(() => {
    if (accessToken) {

      LiferayService.listSuscripciones(properties.base_url_api)
      .then((response) => {
        dispatch({
          payload: response,
          type: ACTIONS.SET_LIST_SUBSCRIPCIONES,
        });
      })
      
      LiferayService.getIdList(properties.base_url_api)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_IDLIST,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  }, [accessToken]);

  React.useEffect(() => {
    if (state.jsonAltaSubscription) {
      LiferayService.altaSuscripcion(properties.base_url_api, state.jsonAltaSubscription)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_ALTA_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  }, [state.jsonAltaSubscription])

  React.useEffect(() => {
    if (state.jsonConfirmationModificationSubscription) {
      LiferayService.confirmModificationSubscription(properties.base_url_api, state.jsonConfirmationModificationSubscription)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_CONFIRMATION_MODIFICATION_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }

  }, [state.jsonConfirmationModificationSubscription])

  React.useEffect(() => {
    if (state.jsonAnulationSubscription) {
      LiferayService.anulationSubscription(properties.base_url_api, state.jsonAnulationSubscription)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_ANULATION_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  }, [state.jsonAnulationSubscription])

  React.useEffect(() => {
    if (state.jsonVerificateModificationSubscription) {
      LiferayService.verificateModificationSubscription(properties.base_url_api, state.jsonVerificateModificationSubscription)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_VERIFICATE_MODIFICATION_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  }, [state.jsonVerificateModificationSubscription])

  React.useEffect(() => {
    if (state.jsonModificationSubscription) {
      LiferayService.modificationSubscription(properties.base_url_api, state.jsonModificationSubscription)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_MODIFICATION_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  }, [state.jsonModificationSubscription])

  React.useEffect(() => {
    if (state.jsonConfirmationAltaSubscription) {
      LiferayService.confirmationAltaSuscripcion(properties.base_url_api, state.jsonConfirmationAltaSubscription)
        .then((response) => {
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            payload: response,
            type: ACTIONS.SET_RESPONSE_CONFIRMATION_ALTA_SUBSCRIPTION,
          });
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }

  }, [state.jsonConfirmationAltaSubscription])

  React.useEffect(() => {
    if (state.idClient) {
      dispatch({
        type:ACTIONS.SET_IDCLIENT_AUX,
        payload: state.idClient
      });
      LiferayService.consultarDetalleCuentaContrato(properties.base_url_api, state.idClient, properties.url_ws_empresa, properties.codigo_empresa)
        .then((response) => {
          dispatch({
            payload: response,
            type: ACTIONS.SET_DETAIL_CLIENT,
          });
          dispatch({
            payload: null,
            type: ACTIONS.SET_ERROR,
          });
          dispatch({
            type: ACTIONS.SET_IDCLIENT,
            payload: ""
          })
        })
        .catch((error) => {
          dispatch({
            payload: error,
            type: ACTIONS.SET_ERROR,
          });
        })
    }
  }, [state.idClient])

  return (
    <SubscriptionsContext.Provider value={[state, dispatch]}>
      {children}
    </SubscriptionsContext.Provider>
  );
};
export default SubscriptionsContextProvider;